import ActionMenuV2 from "components/ActionMenuV2";
import message from "components/CustomMessage";
import TableContainer from "components/TableContainer";
import { PermissionSetMap } from "constants/RBACConstants";
import _ from "lodash";
import React, { useImperativeHandle } from "react";
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";
import ModalUtil from "utils/modalUtil";
import { Sorters, getFilterProps } from "utils/tableUtils";

import AWSIntegrationModalForm from "./AWSIntegrationModalForm";

const items = [
  {
    type: "edit",
    permission: PermissionSetMap.EDIT_TOOL_CONFIG,
  },
  {
    type: "delete",
    permission: PermissionSetMap.DELETE_TOOL,
  },
];

const AWSIntegrationListing = ({
  configurationRef,
  data,
  onUpdateConfigComponent,
  name,
}: {
  configurationRef: React.RefObject<any>;
  data: any;
  onUpdateConfigComponent: () => void;
  name: string;
}) => {
  const onDelete = (id: number) => {
    const { promise } = ToolsIntegrationsAPI.deleteGenericLoginDetail(name, id);
    promise.then(() => {
      message.success("Configuration deleted successfully.");
      onUpdateConfigComponent();
    });
    return promise;
  };

  useImperativeHandle(configurationRef, () => ({
    refresh: () => {
      onUpdateConfigComponent();
    },
  }));

  const onClick = async (_: any, record: any) => {
    switch (record.name) {
      case "edit":
        ModalUtil.show({
          content: (
            //@ts-ignore
            <AWSIntegrationModalForm
              configData={record.data}
              onUpdateConfigComponent={onUpdateConfigComponent}
            />
          ),
        });
        break;
      case "delete":
        await onDelete(record.data.id);
        break;
      default:
        break;
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      sorter: Sorters.STRING("name"),
      ...getFilterProps({
        dataIndex: "name",
        dataSource: data,
      }),
    },
    {
      title: "Role ARN",
      dataIndex: "roleARN",
    },
    {
      title: "External ID",
      dataIndex: "externalId",
    },
    {
      title: "Action",
      key: "action",
      dataIndex: "id",
      width: 50,
      render: (id: any, obj: any) => {
        //@ts-ignore
        return <ActionMenuV2 items={items} onClick={onClick} data={obj} />;
      },
    },
  ];

  return (
    <TableContainer
      loading={_.isUndefined(data)}
      columns={columns}
      dataSource={data}
      title="Configurations"
      defaultSort={{ column: "createdAt", order: "descend" }}
      rowKey={"id"}
    />
  );
};

export default AWSIntegrationListing;
